//@ts-nocheck

import { useEffect, useState } from "react";
import "./SatDesignerSideBar.scss";

import {
  BackButton,
  SatImage,
  MsImagerIcon,
  AntennaIcon,
  SensorsIcon,
  ADCSIcon,
  GPSIcon,
  ThrusterIcon,
  LeftbarCloseSvg,
} from "../SatelliteProfileImgAssets/SatelliteProfileImgAssets";

import { useThermalDesign } from "../ThermalDesignContext";
import { useNavigate, useParams } from "react-router-dom";
import { navigateTo } from "../../../../../utils/commonFunctions";
import TreeNode from "./TreeNode";

const SatDesignerSideBar = ({ addMesh, allSensors, setSelectedSensor, setSelectedSensorHeader, payloads, selectedSensor, onToggleVisibility, meshVisibilityMap }) => {
  const params = useParams();
  const { mission_name, sat_name, mission_id, sat_id } = params;

  const { isSatDesignerSidebarOpen, setIsSatDesignerSidebarOpen } = useThermalDesign();
  const [selectedNodeLabel, setSelectedNodeLabel] = useState<string | null>(null);
  const [busData, setBusData] = useState();
  const [payloadData, setPayloadData] = useState();
  const navigate = useNavigate();

  const addPayloadFunc = (label) => {
    const props = {
      position: [0, 0, 0],
      args: [1, 1, 1],
      name: label,
    };
    addMesh(props);
  };

  const iconDisplayerFunc = (type) => {
    if (type === "MS Imager") return <MsImagerIcon />;
    else if (type === "Antenna") return <AntennaIcon />;
    else if (type === "Sensors") return <SensorsIcon />;
    else if (type === "ADCS") return <ADCSIcon />;
    else if (type === "GPS") return <GPSIcon />;
    else if (type === "Thrusters") return <ThrusterIcon />;
    else return <MsImagerIcon />;
  };

  useEffect(() => {
    if (allSensors) {
      let sensorsTypes = [];
      Object.keys(allSensors)?.map((sensors) => {
        let subSensors = [];
        allSensors[sensors]?.map((subSensor) => {
          subSensors.push({ name: subSensor.name, value: subSensor });
        });
        sensorsTypes.push({
          type: sensors,
          sensorItems: subSensors,
        });
      });

      const busDatas = [
        {
          type: "Sensors",
          sensorTypes: sensorsTypes,
        },
      ];
      setBusData(busDatas);
    }
  }, [allSensors]);

  useEffect(() => {
    if (payloads) {
      let payloadType = [];
      payloads?.map((payload) => {
        if (payload?.atmosData?.component_specific_attributes?.payloadSubType === "Imaging") {
          payloadType.push({ type: payload.name, value: payload });
        }
      });
      setPayloadData(payloadType);
    }
  }, [payloads]);

  const navigate_to_satellite_details = () => {
    navigateTo(`${mission_name}/${mission_id}/sat_details/${sat_name}/${sat_id}/SateliiteProfile?sub_tab=physical_characteristics`, navigate);
  };

  return (
    <>
      <div className="custom-model-sidebar-header ">
        <div
          className="custom-model-sidebar-header-back-button scalingButton"
          onClick={() => {
            navigate_to_satellite_details();
          }}
        >
          <BackButton />
        </div>
        <div className="custom-model-sidebar-header-title">
          <div className="custom-model-sidebar-header-satname">
            <div className="custom-model-sidebar-header-back-button">
              <SatImage />
            </div>
            <span className="custom-model-sidebar-header-label" title={sat_name}>
              {sat_name}
            </span>
          </div>
        </div>
      </div>
      <div className={`custom-model-sidebar ${isSatDesignerSidebarOpen ? "active" : ""}`} id="create_model_sidebar">
        <div className="custom-model-sidebar-container"></div>
        <div className="custom-model-sat-components-div">
          {/* Payload section of code, to be used later */}
          {payloadData && (
            <div className="custom-model-sat-components-payload-detail">
              <div className="custom-model-sat-components-payload-header">
                <div className="custom-model-sidebar-modal-payload-icon-label">
                  <span className="custom-model-sidebar-header-label bus_payload_text">Payload</span>
                  <span className="custom-model-sidebar-modal-payload-count">{payloadData?.length}</span>
                </div>
              </div>
              <div className="custom-model-sat-components-payload-cards-container greyScrollableSectionBar">
                {payloadData.map((item, index) => (
                  <div
                    key={index}
                    className="payload-data-item-level-one"
                    onClick={() => {
                      const tmp = {
                        editable: false,
                        exclusionAngleBool: true,
                        exclusionAngleSunEarthMoon: [45, 25, 0],
                        fov: 10,
                        mass: 110,
                        massBool: false,
                        name: item.type,
                        orientation: [0, 0, 1],
                        sensorType: "payload",
                        size: 0,
                        sizeBool: false,
                      };
                      let newAdd = [{ name: item?.value?.name, value: tmp }];
                      addPayloadFunc();
                      setSelectedSensor(newAdd);
                      setSelectedSensorHeader(false);
                    }}
                  >
                    <div className="payload-data-item-level-one-image">{iconDisplayerFunc(item?.type)}</div>
                    <div className="payload-data-item-level-one-text">{item?.type}</div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* For Bus */}
          {busData &&
            (() => {
              /** Creating parent-child structure using busData to map the tree heirarchy accordingly */
              const sensorTree = busData.map((group) => ({
                label: group.type,
                children: group.sensorTypes.map((sensorType) => ({
                  label: sensorType.type,
                  children: sensorType.sensorItems.map((sensor) => ({
                    label: sensor.name,
                    value: sensor.value,
                  })),
                })),
              }));

              return (
                <div className="custom-model-sat-components-payload-detail">
                  <div className="custom-model-sat-components-payload-header">
                    <div className="custom-model-sidebar-modal-payload-icon-label">
                      <span className="custom-model-sidebar-header-label bus_payload_text">Bus</span>
                      <span className="custom-model-sidebar-modal-payload-count">{busData.length}</span>
                    </div>
                  </div>
                  <div className="tree-container">
                    <ul className="tree-root">
                      {sensorTree.map((node, index) => (
                        <TreeNode
                          key={index}
                          node={node}
                          iconDisplayerFunc={iconDisplayerFunc}
                          addPayloadFunc={addPayloadFunc}
                          setSelectedSensor={setSelectedSensor}
                          setSelectedSensorHeader={setSelectedSensorHeader}
                          selectedNodeLabel={selectedNodeLabel}
                          onSelect={setSelectedNodeLabel}
                          onToggleVisibility={onToggleVisibility}
                          addPayloadFunc={addPayloadFunc}
                          meshVisibilityMap={meshVisibilityMap}
                        />
                      ))}
                    </ul>
                  </div>
                </div>
              );
            })()}
        </div>
      </div>
      <LeftbarCloseSvg active={isSatDesignerSidebarOpen} onClick={() => setIsSatDesignerSidebarOpen(!isSatDesignerSidebarOpen)} />
    </>
  );
};

export default SatDesignerSideBar;
